module.exports = __webpack_public_path__ + "img/widget_02.af314374.png";